<template>
	<div>
		<div style="background: #F5F5F5;">
			<div style="height: 1px;"></div>
			<div class="tabbox">
				<div class="con fcs">
					<div :class="current == 0?'tab-a fcc':'tab fcc'" @click="changecurrent(0)">
						<div>已中标信息</div>
					</div>
					<div :class="current == 1?'tab-a fcc':'tab fcc'" @click="changecurrent(1)">
						<div>未中标信息</div>
					</div>
					<div :class="current == 2?'tab-a fcc':'tab fcc'" @click="changecurrent(2)">
						<div>进行中信息</div>
					</div>
					<div :class="current == 3?'tab-a fcc':'tab fcc'" @click="changecurrent(3)">
						<div>基本信息</div>
					</div>
				</div>
			</div>
			<div class="mian" v-loading="loading">
				<div class="content">
					<div class="title fcc">{{current == 0?'已中标信息':current == 1?'未中标信息':current == 2?'进行中信息':'基本信息'}}
					</div>
					<div v-if="current != 3">
						<div class="list" v-for="(item,index) in list" :key="index">
							<div class="tit">{{item.title}}</div>
							<div class="tim">{{item.createtime}}</div>
						</div>
						<div class="fcc" style="margin: 50px 0;" v-if="list.length != 0">
							<el-pagination background layout="prev, pager, next" :page-size="10" :total="total"
								@current-change="handleCurrentChange">
							</el-pagination>
						</div>
					</div>
					<div v-else>
						<div class="fc">
							<div class="inputbox fc">
								<div style="width: 80px;">公司名称</div>
								<el-input v-model="userinfo.corporate_name" placeholder="请输入公司名称"
									style="width: 250px;"></el-input>
							</div>
							<div class="inputbox fc">
								<div style="width: 80px;">注册分类</div>
								<div style="color: #999999;">
									{{userinfo.category_id == 1?'专项工程分包供应商':userinfo.category_id == 2?'材料供应商':userinfo.category_id == 3?'劳务供应商':userinfo.category_id == 4?'设备供应商':'其他物质供应商'}}
								</div>
							</div>
						</div>
						<div class="fc">
							<div class="inputbox fc">
								<div style="width: 80px;">联系人</div>
								<el-input v-model="userinfo.name" placeholder="请输入联系人名称"
									style="width: 250px;"></el-input>
							</div>
							<div class="inputbox fc">
								<div style="width: 80px;">登录密码</div>
								<div style="color: #999999;">******</div>
							</div>
						</div>
						<div class="fc">
							<div class="inputbox fc">
								<div style="width: 80px;">手机号</div>
								<div style="color: #999999;">{{userinfo.mobile}}</div>
							</div>
							<div class="inputbox fc">

							</div>
						</div>
						<div style="height: 50px;"></div>
						<div class="title fcc">营业执照(图片)</div>
						<img class="img" :src="userinfo.business_license" alt="">
						<div style="margin-top: 50px;"
							v-if="userinfo.category_id == '1' || userinfo.category_id == '3'">
							<div class="title fcc">资质证书</div>
							<img class="img" :src="userinfo.zzzs" alt="">
						</div>
						<div style="margin-top: 50px;" v-if="userinfo.category_id == '4'">
							<div class="title fcc">其他证明资料</div>
							<img class="img" :src="userinfo.sbzmcl" alt="">
						</div>
						<div class="fcc" style="margin-top: 30px;">
							<el-button type="primary" style="width: 140px;" @click="registerbtn">修改</el-button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: false,
				current: 0,
				userinfo: null,
				page: 1,
				list: [],
				total: 0
			}
		},
		created() {
			this.getlist();
			this.getuserinfo();
		},
		methods: {
			//切换tab
			changecurrent(val) {
				this.current = val;
				this.page = 1;
				this.getlist();
			},
			//点击分页
			handleCurrentChange(val) {
				this.page = val;
				this.list = [];
				this.getlist();
			},
			//获取招标公告
			getlist() {
				if (this.current == 3) {
					return;
				}
				let data = {
					page: this.page,
					limit: 10,
					result: this.current == 0 ? '2' : this.current == 1 ? '3' : this.current == 2 ? '1' : ''
				}
				this.loading = true;
				this.$api.home.mynotice(data).then(res => {
					if (res.code == 1) {
						this.list = res.data.list;
						this.total = res.data.total;
					}
					this.loading = false;
				})
			},
			//获取个人信息
			getuserinfo() {
				this.$api.home.userindex().then(res => {
					if (res.code == 1) {
						this.userinfo = res.data;
						console.log(this.userinfo)
					}
				})
			},
			//修改个人信息
			registerbtn() {
				let that = this;
				that.$confirm('确定修改吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let data = {
						name: that.userinfo.name,
						corporate_name: that.userinfo.corporate_name
					}
					that.$api.home.userupdate(data).then(res => {
						if (res.code == 1) {
							that.$message({
								message: '修改成功',
								type: 'success'
							});
							setTimeout(() => {
								location.reload();
							}, 1500)
						}
					})
				}).catch(() => {});
			}
		}
	}
</script>

<style scoped>
	.tabbox {
		width: 100%;
		height: 46px;

		margin-top: 50px;
	}

	.tabbox .con {
		width: 1200px;
		height: 46px;
		background: #0B457A;
		margin: 0 auto;
	}

	.tabbox .con .tab {
		width: 204px;
		height: 46px;
		font-size: 18px;
		margin-right: 20px;
		color: #ffffff;
		cursor: pointer;
	}

	.tabbox .con .tab:hover {
		background: #1872C2;
	}

	.tabbox .con .tab-a {
		width: 204px;
		height: 46px;
		font-size: 18px;
		margin-right: 20px;
		color: #ffffff;
		background: #1872C2;
		cursor: pointer;
	}

	.tabbox .con .tab img {
		width: 22px;
		margin-right: 12px;
	}

	.tabbox .con .tab-a img {
		width: 22px;
		margin-right: 12px;
	}

	.mian {
		width: 1200px;
		margin: 0 auto;
		padding-bottom: 50px;
		position: relative;
	}

	.mian .content {
		background: #ffffff;
		box-sizing: border-box;
		margin: 0 auto;
		padding: 30px 0;
	}

	.mian .content .title {
		display: block;
		height: 40px;
		padding-left: 14px;
		font-size: 22px;
		border-left: #2A69C8 solid 4px;
	}

	.mian .content .inputbox {
		width: 340px;
		margin: 0 auto;
		margin-top: 20px;
	}

	.mian .content .list {
		box-sizing: border-box;
		padding: 20px 30px;
		border-bottom: #f5f5f5 solid 3px;
		cursor: pointer;
	}

	.mian .content .list:hover {
		background: #FAFAFA;
	}

	.mian .content .list:hover .tit {
		color: #6C97EC;
	}

	.mian .content .list .tit {
		font-size: 22px;
	}

	.mian .content .list .tim {
		font-size: 18px;
		color: #999999;
		margin-top: 10px;
	}

	.img {
		width: 200px;
		margin: 30px 50px;
	}
</style>